module.exports = __webpack_public_path__ + "static/media/sjelden.053da54d.m4a";